import React from 'react';
import { Link } from 'react-router-dom';
import Modal from 'react-modal';
import { graphql, compose } from 'react-apollo';

import $ from 'jquery';
import * as MESSAGES from '../Lib/Messages';
import {
  QueryAssessmentsList,
  QueryGetAnalysisIds,
  MutationDeleteAssessment,
  QueryGetFilterPatient,
  MutationDeleteAssessmentAndAnalysis,
} from '../GraphQL/MutationAssessment';
import BreadCrumb from './BreadCrumb';
import Spinner from './Spinner';
import Notification from './Notification';
import ModalContent from './ModalContent';
import moment from 'moment';
import { client } from '../App';
import * as Utils from '../Lib/Utils';

class PatientsList extends React.Component {
  subHandApps = localStorage.getItem('subHandsApps');
  typingTimer = null;
  pagiTimer = null;
  constructor(props) {
    super(props);
    this.state = {
      delObj: {
        therapistId: null,
        assessmentId: null,
      },
      assessmentList: [],
      loading: false,
      errors: {},
      isError: false,
      errorMessage: '',
      modalIsOpen: false,
      limit: 10,
      page: 1,
      lastPage: 999999,
      nextToken: null,
      hasPrev: false,
      hasNext: true,
      hasClick: false,
      keyword: '',
    };

    this.openModal = this.openModal.bind(this);
    this.afterOpenModal = this.afterOpenModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.confirmDelete = this.confirmDelete.bind(this);
  }

  componentDidMount() {
    if (!window.navigator.onLine) {
      this.setState({
        errorMessage: MESSAGES.ERROR_NETWORK_CONNECTION,
        isError: true,
      });
    }

    this.loadData();
  }

  componentWillReceiveProps(newProps) {}

  componentWillMount() {
    Modal.setAppElement('body');
  }

  handleDeleteItem = async (e) => {
    console.log('Deleting an item');
    this.setState({ loading: true });
    this.closeModal();
    if (!window.navigator.onLine) {
      this.setState({
        errorMessage: MESSAGES.ERROR_NETWORK_CONNECTION,
        isError: true,
        loading: false,
      });
      return false;
    }

    let { delObj } = this.state;
    const { deleteAssessment, deleteAssessmentAndAnalysis } = this.props;

    const result = await client.query({
      name: 'getAnalysisIds',
      query: QueryGetAnalysisIds,
      fetchPolicy: 'network-only',
      variables: {
        therapistId: delObj.therapistId,
        assessmentId: delObj.assessmentId,
      },
    });

    delObj['analysisIds'] = [];
    let data = result.data.getAssessment;
    if (data) {
      let items = data.analysis.items;
      if (items) {
        items.map((item, i) => {
          delObj['analysisIds'].push(item.analysisId);
        });
      }
    }

    try {
      let obj;
      if (delObj['analysisIds'].length > 0) {
        obj = await deleteAssessmentAndAnalysis(delObj);
      } else {
        delete delObj['analysisIds'];
        obj = await deleteAssessment(delObj);
      }

      if (!obj.data.errors) {
        this.setState({
          errorMessage: MESSAGES.SUCCESS_DELETE_PATIENT,
          isError: false,
        });

        this.initData();

        var AuthHandsApps = localStorage.getItem('AuthHandsApps');
        if (AuthHandsApps) {
          var user = JSON.parse(AuthHandsApps);
          if (user.email !== undefined) {
            var params = {
              name: user.email + '/' + delObj.assessmentId,
              type: 'DELETE_ALL',
            };

            // Delete all PDF for this patient
            Utils.apiGateway('service/upload-pdf', params, 'POST');
          }
        }
      } else {
        this.setState({
          errorMessage: MESSAGES.ERROR_DELETE_PATIENT,
          isError: true,
        });
      }
    } catch (e) {
      this.setState({
        errorMessage: MESSAGES.ERROR_DELETE_PATIENT,
        isError: true,
      });
    }

    this.setState({ loading: false });
  };

  confirmDelete(obj) {
    this.setState({ delObj: obj });
    this.openModal();
  }

  openModal() {
    this.setState({ modalIsOpen: true });
  }

  afterOpenModal() {
    // console.log('afterOpenModal');
  }

  closeModal() {
    this.setState({ modalIsOpen: false });
  }

  handleSearch = (event) => {
    const {
      target: { value },
    } = event;
    if (value !== '' && value.length <= 2) {
      return false;
    }

    this.setState({ keyword: value });
    var $this = this;
    clearTimeout(this.typingTimer);
    this.typingTimer = setTimeout(function () {
      $this.initData();
    }, 1000);
  };

  loadData = async (e) => {
    this.setState({ loading: true });

    let { limit, page, nextToken, keyword } = this.state;
    let data = {};
    if (!nextToken && page > 1) {
      this.setState({ hasNext: false, loading: false });
      return false;
    }

    if (keyword !== '') {
      let result = await client.query({
        query: QueryGetFilterPatient,
        fetchPolicy: 'network-only',
        variables: {
          therapistId: this.subHandApps,
          keyword: keyword.toLowerCase(),
          limit,
          nextToken,
        },
      });
      if (result.data.getFilterPatient) {
        data = result.data.getFilterPatient;
      }
    } else {
      let result = await client.query({
        query: QueryAssessmentsList,
        fetchPolicy: 'network-only',
        variables: {
          id: this.subHandApps,
          limit,
          nextToken,
        },
      });
      if (result.data.getTherapist) {
        data = result.data.getTherapist.assessments;
      }
    }

    if (data) {
      if (data.items.length > 0) {
        $('.dataTables_empty').parent().remove();
        if (data.items.length < limit) {
          this.setState({ hasNext: false, lastPage: page });
        }
      }

      if (!data.nextToken) {
        this.setState({ hasNext: false });
        if (data.items.length === 0) {
          this.setState({ lastPage: page - 1, loading: false });
          return false;
        } else {
          this.setState({ lastPage: page });
        }
      }

      var assessmentList = [...this.state.assessmentList, ...data.items];
      this.setState({
        assessmentList,
        nextToken: data.nextToken,
      });
    }

    this.setState({ loading: false });
  };

  initData = () => {
    this.setState({
      page: 1,
      lastPage: 999999,
      nextToken: null,
      assessmentList: [],
      hasPrev: false,
      hasNext: true,
    });

    setTimeout(() => {
      this.loadData();
    }, 200);
  };

  changeLimit = (event) => {
    const {
      target: { value },
    } = event;
    this.setState({ limit: value });
    this.initData();
  };

  Prev = () => {
    if (!this.state.hasPrev) {
      return false;
    }

    this.setState({ loading: true });

    var $this = this;
    let { page, lastPage } = this.state;
    clearTimeout(this.pagiTimer);
    this.pagiTimer = setTimeout(function () {
      page--;
      if (page <= 1) {
        page = 1;
        $this.setState({ hasPrev: false });
      }

      $this.setState({ page, hasNext: true, loading: false });
      if (page === lastPage) {
        $this.setState({ hasNext: false });
      }
    }, 200);
  };

  Next = () => {
    if (!this.state.hasNext) {
      return false;
    }

    this.setState({ loading: true });

    var $this = this;
    let { page, limit, lastPage, assessmentList } = this.state;
    clearTimeout(this.pagiTimer);
    this.pagiTimer = setTimeout(function () {
      page++;
      $this.setState({ page, hasPrev: true });
      if (page * limit > assessmentList.length) {
        $this.loadData();
      } else {
        if (page === lastPage) {
          $this.setState({ hasNext: false });
        }
        $this.setState({ loading: false });
      }
    }, 500);
  };

  render() {
    const { loading } = this.state;
    const { assessmentList, limit, page } = this.state;
    let patients = assessmentList.filter((item, index) => {
      return index < limit * page && index >= limit * (page - 1);
    });

    return (
      <section role='main' className='content-body'>
        <Modal
          isOpen={this.state.modalIsOpen}
          onAfterOpen={this.afterOpenModal}
          onRequestClose={this.closeModal}
          className='mfp-content'
          overlayClassName='mfp-bg'
        >
          <ModalContent
            onHide={this.closeModal}
            handleModal={this.handleDeleteItem.bind(this)}
            title='Are you sure you want to delete this user?'
            message='Please confirm. This action cannot be undone.'
          />
        </Modal>

        <header className='page-header'>
          <h2>Patients</h2>
          <BreadCrumb title1='Patients' title2='List' />
        </header>

        <Notification
          isError={this.state.isError}
          message={this.state.errorMessage}
        />

        <div className='row'>
          <div className='col-lg-12'>
            <section className='card'>
              <div
                className={`card-body${
                  this.props.loading || loading
                    ? ' loading-overlay-showing'
                    : ''
                }`}
              >
                <Spinner />
                <Link
                  className='btn btn-primary btn-ass-create'
                  to='/patients/create'
                  style={{ position: 'relative', marginBottom: 10 }}
                >
                  Create <i className='fa fa-plus'></i>
                </Link>
                <div className='dataTables_wrapper'>
                  <div className='row'>
                    <div className='col-lg-6'>
                      <div
                        className='dataTables_length'
                        id='datatable-tabletools_length'
                      >
                        <label>
                          <select
                            className='form-control form-control-sm'
                            onChange={this.changeLimit.bind(this)}
                            value={limit}
                          >
                            <option value='10'>10</option>
                            <option value='25'>25</option>
                            <option value='50'>50</option>
                            <option value='100'>100</option>
                          </select>{' '}
                          records per page
                        </label>
                      </div>
                    </div>
                    <div className='col-lg-6'>
                      <div
                        id='datatable-tabletools_filter'
                        className='dataTables_filter'
                      >
                        <label>
                          <input
                            type='search'
                            className='form-control pull-right'
                            placeholder='Search...'
                            aria-controls='datatable-tabletools'
                            onChange={this.handleSearch.bind(this)}
                          />
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
                <table
                  className='table table-responsive-lg table-bordered table-striped mb-0'
                  id='datatable-default'
                >
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>First Name</th>
                      <th>Last Name</th>
                      <th>Birthday</th>
                      <th>Medical Record ID</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {[]
                      .concat(patients)
                      .sort((a, b) => b.created.localeCompare(a.created))
                      .map((item, i) => (
                        <tr key={(page - 1) * limit + i + 1}>
                          <td className='center'>
                            {(page - 1) * limit + i + 1}
                          </td>
                          <td>{item.firstName}</td>
                          <td>{item.lastName}</td>
                          <td>
                            {item.birthday
                              ? moment(item.birthday, 'MM/DD/YYYY').format(
                                  'DD MMMM YYYY'
                                )
                              : ''}
                          </td>
                          <td>{item.medicalNumber}</td>
                          <td className='center actions'>
                            <Link
                              to={'/assessments/list/' + item.assessmentId}
                              className='on-default'
                              title='Assessments List'
                            >
                              <i className='fas fa-list-alt fa-lg'></i>
                            </Link>
                            &nbsp;
                            <Link
                              to={'/assessments/create/' + item.assessmentId}
                              className='on-default'
                              title='Create Assessment'
                            >
                              <i className='fas fa-allergies fa-lg'></i>
                            </Link>
                            &nbsp;
                            <Link
                              to={'/patients/' + item.assessmentId}
                              className='on-default'
                              title='Edit Patient'
                            >
                              <i className='fas fa-pencil-alt fa-lg'></i>
                            </Link>
                            &nbsp;
                            <a
                              href='javascript:void(0)'
                              className='on-default'
                              title='Remove Patient'
                              onClick={() =>
                                this.confirmDelete({
                                  therapistId: this.subHandApps,
                                  assessmentId: item.assessmentId,
                                })
                              }
                            >
                              <i className='fas fa-trash-alt fa-lg'></i>
                            </a>
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table>
                <div className='dataTables_wrapper'>
                  <div
                    className='dataTables_paginate paging_simple_numbers'
                    id='datatable-tabletools_paginate'
                  >
                    <ul className='pagination'>
                      <li
                        className={`paginate_button page-item previous${
                          this.state.hasPrev ? '' : ' disabled'
                        }`}
                        id='datatable-tabletools_previous'
                        onClick={this.Prev.bind(this)}
                      >
                        <a href='javascript:void(0)' className='page-link'>
                          Previous
                        </a>
                      </li>
                      <li
                        className={`paginate_button page-item next${
                          this.state.hasNext ? '' : ' disabled'
                        }`}
                        id='datatable-tabletools_next'
                        onClick={this.Next.bind(this)}
                      >
                        <a href='javascript:void(0)' className='page-link'>
                          Next
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
      </section>
    );
  }
}

export default compose(
  graphql(MutationDeleteAssessment, {
    options: {
      refetchQueries: [
        {
          query: QueryAssessmentsList,
          variables: { id: localStorage.getItem('subHandsApps') },
        },
      ],
    },
    props: (props) => ({
      deleteAssessment: (assessment) => {
        return props.mutate({
          variables: assessment,
          optimisticResponse: () => ({
            deleteAssessment: {
              ...assessment,
              __typename: 'Assessment',
            },
          }),
        });
      },
    }),
  }),
  graphql(MutationDeleteAssessmentAndAnalysis, {
    options: {
      refetchQueries: [
        {
          query: QueryAssessmentsList,
          variables: { id: localStorage.getItem('subHandsApps') },
        },
      ],
    },
    props: (props) => ({
      deleteAssessmentAndAnalysis: (assessment) => {
        return props.mutate({
          variables: assessment,
          optimisticResponse: () => ({
            deleteAssessmentAndAnalysis: {
              ...assessment,
              __typename: 'Assessment',
            },
          }),
        });
      },
    }),
  })
)(PatientsList);
